<form data-cy="generic-multiselect-checkbox__form-form" [formGroup]="form" *transloco="let t" (click)="onComponentClick()">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label >{{ placeholder | capitaliz  }}</mat-label>
    <input data-cy="generic-multiselect-checkbox__text-input"
      #mySelect
      matInput
      [matAutocomplete]="auto"
      [matChipInputFor]="list"
      formControlName="text"
      [disabled]="disabled || readOnly"
      [matTooltip]="disabled && type=='subprojects' ? ('error.no_projects' | transloco) : ''"
      [class]="uniqueId"
      (blur)="onInputBlur()"
    />
    <mat-chip-grid
      [ngClass]="{ disable_enitiy: disabled }"
      [multiple]="false"
      #list
      [class]="showChips ? '' : 'hidden'"
      [disabled]="disabled"
    >
      <mat-chip-row
        class="name-overflow"
        [class.bg-notification]="contextTypes.includes(name) && option.value?.is_suggested"
        *ngFor="let option of selectedOptions"
        [ngClass]="type == 'stakeholders' ? 'chip-custom d-cursor-hand' : ''"
        [disabled]="option?.value?.is_disabled"
        [removable]="
          !isDisabled && option.optionType !== MultiselectOptionType.moremarker
          "
        (removed)="!readOnly && removeOption(option)"
        [matTooltip]="option.content"
        matTooltipClass="tooltip-list"
      >
        <ngx-avatars
          class="ml--6"
          *ngIf="type == 'subprojects' && option.value"
          [style]="AvatarCustomStyle"
          [name]="option.content"
          initialsSize="2"
          size="25"
          [borderColor]="option.value.color"
          [fgColor]="option.value.color"
          bgColor="#FFFFFF"
        >
        </ngx-avatars>
        <span data-cy="generic-multiselect-checkbox__click-option" class="name-chip-overflow" [class.clr-blue]="true" (click)="clickOption(option.value)">
          {{
            maxChipLength
              ? (option.content | trunc : maxChipLength)
              : option.content
          }}
        </span>
        <span *ngIf="chipDisabler.includes(option.content)">
          <!-- <mat-icon *ngIf="!isDisabled && option.optionType !== MultiselectOptionType.moremarker" matChipRemove>cancel</mat-icon> -->
        </span>
        <span *ngIf="!chipDisabler.includes(option.content) && !hideCancleIcon && !option.value?.is_suggested">
          <mat-icon
            *ngIf="
              (!isDisabled &&
              option.optionType !== MultiselectOptionType.moremarker) &&
              (!(mustSelected.has(option.value ? option.value.module_id ? option.value.module_id : '' : '') && name !== 'sharables'))
            "
            matChipRemove
            >cancel</mat-icon
          >
        </span>
        <span class="chip-icons" *ngIf="contextTypes.includes(name) && option.value?.is_suggested">
          <span *ngIf="!chipDisabler.includes(option.content) && !hideCancleIcon">
            <mat-icon
              *ngIf="
                (!isDisabled &&
                option.optionType !== MultiselectOptionType.moremarker) &&
                (!(mustSelected.has(option.value ? option.value.module_id ? option.value.module_id : '' : '') && name !== 'sharables'))
              "
              [class.cancel-icon]="contextTypes.includes(name)"
              matChipRemove
              >cancel</mat-icon
            >
          </span>
          <span data-cy="generic-multiselect-checkbox__action" class="check" (click)="$event.stopPropagation();onClickCheckIcon(option)">
            <mat-icon class="uil uil-check-circle" *ngIf="!loadingOptions.get(option.value?.id) && !option.value?.isCreated && option.value?.is_suggested"></mat-icon>
            <mat-spinner [height]="16" [height]="18" *ngIf="loadingOptions.get(option.value?.id) && !option.value?.isCreated && option.value?.is_suggested"></mat-spinner>
          </span>
        </span>
      </mat-chip-row>

    </mat-chip-grid>
    <ng-template #template>
      <div data-cy="generic-multiselect-checkbox__page">
        <div *ngFor="let option of remainingOptions">
          {{ option.content }}
        </div>
      </div>
    </ng-template>
  </mat-form-field>
  <mat-autocomplete
    #auto="matAutocomplete"
    (click)="$event.preventDefault(); $event.stopPropagation()"
    [class]="!multiple ? 'generic-multiselect-checkbox--single' : ''"
    (closed)="resetInput()"
  >
    <mat-option
      [applyTaggingAttributes]="multiSelectOverlay"
      *ngIf="multiple && showSelectAll && (filteredOptions.length <=15 || disAllowCapping)"
      [value]="selectAllOption"
      (click)="toggleOption(selectAllOption, $event)"
      [class]="uniqueId + '-list-item-0'"
    > 
      <div class="disp-flex">
        <p class="para-all">{{'all' | transloco}}</p>
        <!-- <span>
          <mat-checkbox
          [checked]="selectAllOption.checked"
          (click)="$event.preventDefault()"
          >{{ selectAllOption.content }}</mat-checkbox
          >
        </span> -->
        <p class="slct-all" (click)="$event.preventDefault()">{{ selectAllOption.content }}</p>
      </div>
      <!-- <mat-divider *ngIf="!selectReferUser"></mat-divider> -->
    </mat-option>
    <mat-option
      [applyTaggingAttributes]="multiSelectOverlay"
      *ngFor="let option of filteredOptions; let index = index"
      [value]="option"
      [class]="uniqueId + '-list-item-' + (index + 1)"
      (mousedown)="$event.preventDefault()"
      [disabled]="option.value?.is_disabled"
    >
      <div *ngIf="option.content == 'Selecteer stakeholder(s) accounthouder'">
        <div
          (click)="!option.value?.is_disabled && toggleOption(option, $event)"
          [ngClass]="{
            disable_enitiy:
              chipDisabler.includes(option.content) ||
              option.value.is_permission ||
              option.value?.is_disabled
          }"
        >
          <mat-checkbox data-cy="generic-multiselect-checkbox__checkbox" [checked]="option.checked" [disabled]="option.value?.is_disabled" (click)="$event.stopPropagation()">{{
            option.content
          }}</mat-checkbox>
        </div>
      </div>
      <!--Todo: tagging of option is causing collisio-->
      <div *ngIf="option.content !== 'Selecteer stakeholder(s) accounthouder'">
        <div
          [ngClass]="{
            disable_enitiy:
              chipDisabler.includes(option.content) ||
              option.value.is_permission ||
              option.value?.is_disabled 
          }"
        >
          <mat-checkbox data-cy="generic-multiselect-checkbox__checkbox-2" (click)="!option.value?.is_disabled && toggleOption(option, $event);$event.stopPropagation()" [checked]="option.checked"  [disabled]="option.value?.is_disabled"
          >{{
            option.content
          }}</mat-checkbox>
        </div>
      </div>
      <mat-divider
        *ngIf="option.content == 'Selecteer stakeholder(s) accounthouder'"
      ></mat-divider>
    </mat-option>
    <mat-option
      [applyTaggingAttributes]="multiSelectOverlay"
      *ngIf="showAddAction"
      [value]="addActionOption"
      [innerHTML]="addActionOption.content"
      (click)="toggleOption(addActionOption)"
    ></mat-option>
    <ng-container
      *ngIf="showSearchProject && searchResponse$ | async as searchResponse"
    >
      <mat-divider></mat-divider>
      <mat-option [applyTaggingAttributes]="multiSelectOverlay"
        >{{ searchResponse.length }} {{ searchType }}
        {{ t("text.found_project_level") }}</mat-option
      >
      <mat-option
        [applyTaggingAttributes]="multiSelectOverlay"
        *ngFor="let result of searchResponse"
        [value]="result"
        [disabled]="result.value?.is_disabled || !searchProjectCmp.canLinkProjectLevel()"
        (click)="(!result.value?.is_disabled && searchProjectCmp.canLinkProjectLevel()) && selectSearchedOption(result)"
      >
        <mat-checkbox data-cy="generic-multiselect-checkbox__checkbox-3"
          [checked]="result.checked"
          [disabled]="result.value?.is_disabled || !searchProjectCmp.canLinkProjectLevel()"
          (click)="$event.preventDefault()"
          >{{ result.content }}</mat-checkbox
        >
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</form>
